import React from "react";
import {Field, reduxForm} from "redux-form";
import {Input, InputWithPlaceholder} from "../../Utilits/Fields";
import {FieldIsRequared} from "../../Utilits/Validate";


const LoginForm = (props) => {
    return(
        <form onSubmit={props.handleSubmit}>
            <div className="login__window-title"><h3>Входите и наслаждайтесь!</h3></div>
            <div className='login__input-field'>
                <div className='login__field'>
                    <Field component={InputWithPlaceholder} name='email' validate={[FieldIsRequared]} type="text" id="inp" placeholders="Your  Email" placeholder='&nbsp;'/>
                </div>
                <div className='login__field'>
                    <Field component={InputWithPlaceholder} name='password' validate={[FieldIsRequared]} type="password" id="inp" placeholders="Your  Password" placeholder='&nbsp;'/>
                </div>
                <div className='login__field-checkbox login__field'>
                    <Field component={Input} type='checkbox' name='rememberMe'/>
                    <label>Запомнить меня</label>
                </div>
                {props.error ?
                    <p className='login__full_error full_error main-text'>{props.error}</p> : null
                }
                {props.captcha ?
                    <>
                        <div className='login__field'>
                            <Field component={InputWithPlaceholder} name='captcha' validate={[FieldIsRequared]} type="text" id="inp" placeholders="Your  Captcha" placeholder='&nbsp;'/>
                        </div>
                        <div className='login__capctha'><img src={props.captcha} alt=""/></div>
                    </> : null}
                <div className="submit-button"><button>Войти</button></div>
            </div>
        </form>
    )
};

export default reduxForm({form: "login"})(LoginForm)